require('babel-polyfill'); // idempotent-babel-polyfill

// window.moment = require('moment');
// moment.locale('fr');

window.Vue = require('vue');

require('./helpers/gtm')

import { parseNumber, isValidNumber } from 'libphonenumber-js'

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

require('vue-tour/dist/vue-tour.css')
Vue.use(() => import('vue-tour'))

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

Vue.component('font-awesome-icon', () => import('@fortawesome/vue-fontawesome'))

import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2);


import * as components from './components'

Object.values(components).forEach((component) => {
    Vue.use(component)
});

import { Checkout, ToBeContacted } from "../professional/containers/Subscriptions";

Vue.component(Checkout.name, Checkout);
Vue.component(ToBeContacted.name, ToBeContacted);

Vue.component('search-form', () => import('./pages/Search/Form'))

import {router} from './routes'
import store from './store'

import Meta from 'vue-meta'

Vue.use(Meta)

import fr from 'vee-validate/dist/locale/fr';
import VeeValidate, {Validator} from 'vee-validate'

Validator.localize('fr', fr)

Validator.extend('phone', {
    getMessage: field => `The ${field} field is not a valid phone number.`,
    validate: value => {
        value = value || ''
        return isValidNumber(value, 'FR')
    },
});

Validator.extend('siret', {
    getMessage: field => `The ${field} field is not a valid SIRET number.`,
    validate: value => {
        let siret = value.replace(/\s/g, '')
        let sum = 0
        for (var i = 0; i < 14; i++) {
            let tmp = (((i + 1) % 2) + 1) * parseInt(siret.charAt(i))
            if (tmp >= 10)
                tmp -= 9
            sum += tmp
        }
        return sum % 10 === 0
    },
});

const dict = {
    en: {
        messages: {
            phone: field => `The ${field} field is not a valid phone number.`,
            siret: field => `The ${field} field is not a valid siret number.`
        },
    },
    fr: {
        messages: {
            phone: field => `Le champ ${field} n'est pas un numéro de téléphone valide.`,
            siret: field => `Le champ ${field} n'est pas un numéro de siret valide.`
        },
    },
};

Validator.localize(dict)

Vue.use(VeeValidate)

import GoogleAuth from './config/GoogleAuth'
Vue.use(GoogleAuth)

import slugify from 'slugify'
import { detect } from 'detect-browser'
const browser = detect()

window.dataLayer = window.dataLayer || []
Vue.prototype.$dataLayer = Vue.dataLayer = window.dataLayer

const app = new Vue({
    el: '#site',
    router,
    store,
    methods: {
        toggleMenuListener() {
            let $navBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)

            if ($navBurgers.length > 0) {
                $navBurgers.forEach(function (el) {
                    el.addEventListener('click', () => {
                        // Get the target from the "data-target" attribute
                        const target = el.dataset.target
                        const $target = document.getElementById(target)

                        // Toggle the "active" class & toggle aria attributes
                        el.classList.toggle('is-active')
                        el.setAttribute('aria-expanded', !(el.getAttribute('aria-expanded') === 'true'))

                        $target.classList.toggle('is-active')
                        $target.setAttribute('aria-hidden', !($target.getAttribute('aria-hidden') === 'true'))
                    })
                })
            }
        },
        toggleSearchFixed() {
            /*window.addEventListener('scroll', function (event) {
                let $searchForms = Array.prototype.slice.call(document.querySelectorAll('.js-homeSearch-form'), 0)
                if ($searchForms.length > 0) {
                    if (event.pageY > 300) {
                        $searchForms.forEach(function (el) {
                            el.classList.add('homeSearch-form--fixed')
                        })
                    } else {
                        $searchForms.forEach(function (el) {
                            el.classList.remove('homeSearch-form--fixed')
                        })
                    }
                }
            })*/
        },
        logout() {
            // this.deleteCookie('token');
            window.localStorage.clear()

            dataLayer.push({
                event: 'logoutUser',
                eventCallback: () => {
                    window.location.replace('/deconnexion')
                },
            })
        },
        setCookie(name, value, expireDays) {
            var d = new Date();
            d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        deleteCookie(name) {
            var d = new Date(); //Create an date object
            d.setTime(d.getTime() - (1000 * 60 * 60 * 24)); //Set the time to the past. 1000 milliseonds = 1 second
            var expires = "expires=" + d.toGMTString(); //Compose the expirartion date
            window.document.cookie = name + "=" + "; " + expires;//Set the cookie with name and the expiration date

        },
    },
    mounted() {
        this.toggleMenuListener()

        this.toggleSearchFixed()

        document.body.classList.add(`browser-${slugify(browser.name, {
            lower: true,
        })}`, `version-${slugify(browser.version, {
            lower: true,
        })}`, `os-${slugify(browser.os, {
            lower: true,
        })}`)
    },
    metaInfo() {
        return {
            title: 'Simplifiez vos recherches immobilières !',
            titleTemplate: `%s - Cherche Mon Nid`,
        }
    },
})



// WEBPACK FOOTER //
// ./application/assets/js/site/site.js